import * as React from 'react'

import MuiDateTimePicker, { DateTimePickerProps } from 'material-ui-pickers/DateTimePicker'

const DateTimePicker = (props: DateTimePickerProps) =>
  <MuiDateTimePicker {...props} />

export default DateTimePicker



// WEBPACK FOOTER //
// ./src/components/atoms/DateTimePicker.tsx